import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

const notes = [
  {
    id: "not-guaranteed",
    title: "編入は保証されません",
    text: "コミカレから4年制大学への編入は、自動的に決まるものではありません。改めて出願し、審査を受ける必要があります。",
  },
  {
    id: "conditions",
    title: "条件は大学・専攻ごとに違います",
    text: "必要なGPA、単位数、出願資格は、編入先の大学や専攻によって異なります。年度ごとに見直されることもあります。",
  },
  {
    id: "credits",
    title: "単位がすべて使えるとは限りません",
    text: "取得した単位が、編入先の卒業要件にすべて使えるとは限りません。合格後に単位評価を受けます。",
  },
  {
    id: "cost",
    title: "コミカレ経由が必ず最安とは限りません",
    text: "費用を抑えやすい選択肢のひとつではありますが、地域・期間・生活費によって総額は変わります。",
  },
  {
    id: "fees",
    title: "エージェントなしでも費用はかかります",
    text: "学費、出願料、ビザ関連の費用、渡航費は必要です。エージェントを使わないことは費用ゼロを意味しません。",
  },
  {
    id: "tsi",
    title: "TSIA2の条件は個別に確認を",
    text: "受験が必要かどうか、免除に該当するかは、入学予定校の案内で確認してください。合否を決める試験ではありません。",
  },
  {
    id: "operator",
    title: "運営者は編入準備中です",
    text: "運営者は現在コミカレ在籍中で、編入を経験済みではありません。制度情報と個人の体験談は分けて書いています。",
  },
];

export default function ImportantNotes() {
  return (
    <section className="w-full bg-foreground-950">
      <div className="mx-auto w-full max-w-content px-5 py-16 md:px-6 md:py-20">
        <Reveal className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-300">
              Before you start
            </p>
            <h2 className="mt-3 font-heading text-[26px] font-bold leading-[1.5] tracking-tight text-background-50 md:text-[32px]">
              誤解しないでほしいこと
            </h2>
          </div>
          <p className="max-w-md text-[12.5px] leading-[1.95] text-background-300 md:text-right">
            留学情報は、期待どおりに進まない前提を知っておくことが大切です。当サイトでは、良い面だけでなく条件と注意点もあわせて書いています。
          </p>
        </Reveal>

        <ul className="mt-10 grid gap-x-8 gap-y-7 sm:grid-cols-2 lg:grid-cols-3">
          {notes.map((note, index) => (
            <Reveal
              key={note.id}
              as="li"
              delay={(index % 3) * 70}
              className="border-t border-background-700/60 pt-5"
            >
              <div className="flex items-center gap-2">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-500/15 text-primary-300">
                  <i className="ri-information-line text-[13px]" />
                </span>
                <h3 className="font-heading text-[14px] font-bold text-background-50">
                  {note.title}
                </h3>
              </div>
              <p className="mt-2.5 text-[12px] leading-[1.9] text-background-300">{note.text}</p>
            </Reveal>
          ))}
        </ul>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-700/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[11.5px] leading-[1.9] text-background-400">
            制度の基本は無料記事で、運営者の方針は自己紹介ページで確認できます。
          </p>
          <Link
            to="/about"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full border border-background-600 px-5 py-2.5 text-[12.5px] font-semibold text-background-50 transition-all duration-200 hover:-translate-y-[2px] hover:border-primary-400 hover:text-primary-300"
          >
            運営者と情報公開の方針
            <i className="ri-arrow-right-line text-[14px]" />
          </Link>
        </div>
      </div>
    </section>
  );
}